import { defineComponent as _defineComponent } from 'vue'
import { beneficiaryTableFields } from '../models/beneficiaryTableFields';
import { BeneficiaryCategory, BeneficiaryStatus, PaginatedResponse, Beneficiary } from 'ah-api-gateways';

import BeneficiaryListing from './BeneficiaryListing.vue';
import { waitForCQRSEntityChange } from 'ah-requests';
import { mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { computed, reactive, ref } from 'vue';
import { useBeneficiariesState } from 'ah-beneficiaries';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'BeneficiaryApproval',
  setup(__props) {

const requestManager = useRequestManager({
  exposeToParent: false,
});

const beneficiaryListing = ref<InstanceType<typeof BeneficiaryListing> | null>(null);

const state = reactive({
  data: null as PaginatedResponse<Beneficiary> | null,
});

const beneficiarieState = useBeneficiariesState();

const partnerName = computed(() => {
  return beneficiarieState.theme.name;
});

const filter = computed(() => {
  return {
    status: [BeneficiaryStatus.PENDING],
    category: BeneficiaryCategory.CLIENT_3RD_PARTY,
  };
});

const size = computed(() => {
  return state.data ? state.data.total : 0;
});

const beneficiaryTableConfig = computed(() => {
  return {
    tableFields: beneficiaryTableFields,
  };
});

function isLoading(beneficiary: Beneficiary, status: BeneficiaryStatus) {
  return requestManager.manager.requestStates[beneficiaryRequestKey(beneficiary, status)] === 'pending';
}

function beneficiaryRequestKey(beneficiary: Beneficiary, status: BeneficiaryStatus) {
  return `change-beneficiary-${beneficiary.id}-${status}-status`;
}

function setBeneficiaryApproval(beneficiary: Beneficiary, status: BeneficiaryStatus) {
  requestManager.manager
    .sameOrCancelAndNew(
      beneficiaryRequestKey(beneficiary, status),
      beneficiarieState.services.beneficiary.setBeneficiaryApproval(beneficiary.id, status).pipe(
        mergeMap((idEntity) =>
          waitForCQRSEntityChange(idEntity, () =>
            beneficiarieState.services.beneficiary.getBeneficiary(idEntity.id, {
              errors: { silent: true },
            })
          )
        )
      )
    )
    .pipe(catchError(() => of(beneficiary)))
    .subscribe(() => {
      const entryIndex = state.data?.list.findIndex((e) => e.id === beneficiary.id) ?? -1;
      if (entryIndex > -1) {
        state.data!.list.splice(entryIndex, 1);
      }
    });
}

return { __sfc: true,requestManager, beneficiaryListing, state, beneficiarieState, partnerName, filter, size, beneficiaryTableConfig, isLoading, beneficiaryRequestKey, setBeneficiaryApproval, BeneficiaryStatus, BeneficiaryListing }
}

})